import * as React from "react"
import "./styles/about.css"
import Layout from "../components/layout/layout";
import We from "../components/about/we/we";
import Facts from "../components/about/facts/facts";

const AboutPage = () => {
    return (
        <Layout isHomePage={false} pageName={"About Us"}>
            <We isHomePage={false}/>
            <div className="container">
                <p className="lead fs-18 my-3">
                    <i className="text-orange bi bi-arrow-right-short"/>
                    Texbond Nonwovens an ISO Certified along with approved suppliers of IKEA was established in 2006,
                    are the pioneers of manufacturing polypropylene spunbond nonwoven fabric in India. The entire range
                    of fabrics is manufactured using superior quality raw material and state-of-the- art technology to
                    ensure reliability. PP spunbond nonwoven fabrics are produced using extrusion based technology. The
                    polymer is stretched into a continuous filament and loosely spread on to a conveyer belt to form the
                    web. Air is used to form and lay the fabric filaments. Polypropylene fabrics are harmless to health
                    and do not pollute the environment, neither in production nor in use. The production capacity of our
                    units 10,000MT per annum.
                </p>
                <p className="lead fs-18 my-3">
                    <i className="text-orange bi bi-arrow-right-short"/>
                    We offer an extensive range of modern technologically advanced nonwovens, such as hydrophobic,
                    hydrophilic, flame retardant and laminated with other products and also are able to provide our
                    customers with high quality service at competitive prices. Innovation and Development of new
                    products is the mission of Texbond and investing in the long term as partners to our customers,
                    catering to the needs of following industries globally.
                </p>
            </div>
            <Facts/>
        </Layout>
    )
}

export default AboutPage